import { render, staticRenderFns } from "./trainingEvaluationTotal.vue?vue&type=template&id=4d5f3168"
import script from "./trainingEvaluationTotal.vue?vue&type=script&lang=js"
export * from "./trainingEvaluationTotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports